'use client';

import React, { FC } from 'react';
import NextImage from '@/src/components/ui/nextImage/NextImage';
import styles from './AdvantageList.module.scss';
import { IAdvInfo } from '@/src/lib/types/advantageInterface/index';

type TAdvList = {
  advList: IAdvInfo[];
  middle?: boolean;
};

const AdvantageList: FC<TAdvList> = ({ advList, middle }) => {
  return (
      <ul className={`${styles.adv__list} ${middle ? styles.adv__list_middle : ''}`}>
        {advList.map((item, i) => (
            <li className={styles.adv__item} key={`${item.advName}-${i}`}>
              <div className={styles.logo__wrapper}>
                <NextImage
                    src={item.advLogo}
                    alt={item.advAlt}
                    fill
                    sizes="(max-width: 480px) 24px, 32px"
                />
              </div>
              <p className={styles.name}>{item.advName}</p>
              <p className={`excerpt ${styles.excerpt}`}>{item.advDescr}</p>
            </li>
        ))}
      </ul>
  );
};

export default AdvantageList;
